import {TicketVo} from '../../common/shared/api/gateway/TicketVo.interface';
import {ContentCheckFreeTicket} from '../generated/types';
import {createTicketSum} from './TicketSum';

export function createContentCheckFreeTicket(result: {
  list: TicketVo[];
}): ContentCheckFreeTicket {
  return {list: !result?.list ? [] : result.list.map(createTicketSum)};
}
